import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { NavLink } from "react-router-dom";
import { Variables } from "../../Variations/Variations";
import { BiEdit, BiShowAlt, BiHide } from "react-icons/bi";
import { ToastContainer, toast } from "react-toastify";
import { AiOutlineClose, AiOutlineCheck, AiOutlineRight } from "react-icons/ai";

const ListBlog = () => {
  const [rows, setRows] = useState([]); // [] so DataTable never gets undefined
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      name: "ID",
      selector: (row) => row.Id,
      sortable: true,
      width: "100px",
    },
    {
      name: "Name",
      selector: (row) => row.Title,
      sortable: true,
      wrap: true,
    },
    {
      name: "Image",
      selector: (row) =>
        row.Image && row.Image.trim() !== "" ? (
          <img
            alt="preview"
            src={Variables.API_PUBLISHED + row.Image}
            style={{ width: "100px", padding: "5px" }}
          />
        ) : (
          "-" // show dash if no image
        ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Widget Name",
      selector: (row) => row.Name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Published",
      sortable: true,
      center: true,
      width: "120px",
      cell: (row) =>
        row.IsPublished ? <AiOutlineCheck /> : <AiOutlineClose />,
    },
    {
      name: "Options",
      width: "200px",
      cell: (row) => (
        <div className="d-flex">
          <NavLink
            to={`/admin/rasha/Blog/${row.Id}`} // keep casing consistent everywhere
            className="btn btn-outline-secondary btn-sm"
          >
            <BiEdit />
          </NavLink>

          <button
            className="btn btn-outline-danger btn-sm ms-2"
            onClick={() => togglePublish(row.Id)}
            title={row.IsPublished ? "Unpublish" : "Publish"}
          >
            {row.IsPublished ? <BiHide /> : <BiShowAlt />}
          </button>
        </div>
      ),
    },
  ];

  async function togglePublish(id) {
    try {
      const res = await fetch(
        `${Variables.API_URL}Rasha/Blog/UpsertPublish/${id}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      const msg = await res.json();
      if (!res.ok) {
        toast.error(typeof msg === "string" ? msg : "Failed to update");
        return;
      }

      toast.success(typeof msg === "string" ? msg : "Updated");
      // refresh
      await getBlog();
    } catch (e) {
      toast.error("Network error while updating publish state");
    }
  }

  async function getBlog() {
    setLoading(true);
    try {
      const res = await fetch(`${Variables.API_URL}Rasha/Blog/Get`);
      if (!res.ok) throw new Error("Did not receive expected data");
      const listItems = await res.json();
      console.log(listItems);

      const flat = (listItems || []).map((x) => ({
        Id: x?.Blog?.Id ?? 0,
        Title: x?.Blog?.Title ?? "",
        Name: x?.WidgetDetails?.Name ?? "",
        IsPublished: !!x?.Blog?.IsPublished,
        Image: x?.Blog?.ImageUrl ?? "",
        _raw: x,
      }));

      setRows(flat);
    } catch (e) {
      toast.error("Failed to load Blog");
      setRows([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getBlog();
  }, []);

  return (
    <div className="rightSide">
      <div className="container-fluid mt-3">
        <div className="row">
          <div className="col-12">
            <h2>List Blogs</h2>
            <ul className="portalPath">
              <li>
                Home <AiOutlineRight />
              </li>
              <li>List Blogs</li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="col-12 mb-3 text-end">
                  <NavLink to="/admin/rasha/Blog/0" className="btn btn-primary">
                    Add Blog
                  </NavLink>
                </div>

                <div className="portalTable">
                  <DataTable
                    keyField="Id"
                    columns={columns}
                    data={rows}
                    progressPending={loading}
                    pagination
                    highlightOnHover
                    dense
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
        />
      </div>
    </div>
  );
};

export default ListBlog;
